// @flow

import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import SkeletonLoaderWrapper from "../../../components/mui/general/skeletonLoaderWrapper/skeletonLoaderWrapper";
import { access_registrations, access_user } from "../../../helpers/rights";
import { withPermissionHOC } from "../../permission/components/permissionHOC/permissionHOC";
import useRegistration from "../hooks/useRegistration";
import { REGISTRATIONS } from "../locales/namespaces";
import Form from "./form";

type Props = {};

const Create = (props: Props) => {
	const { t } = useTranslation(REGISTRATIONS)
	let { registrationId } = useParams()
	if (!registrationId) {
		registrationId = props.registrationId
	}
	useEffect(() => {
		document.title = !registrationId ? t('New Registration') : t('Edit Registration')
	}, [])
	
	// const {loading, project,assignees,projectWorks} = useProject({registrationId})
	const {
		loading,
		registration,
		projects,
		users,
		workers,
		projectWorks
	} = useRegistration({ registrationId })
	
	
	return (
		<SkeletonLoaderWrapper loading={loading}>
			{/*{((registrationId && projectWorks.length > 0) || (!registrationId && workers.length > 0)) && (*/}
				<Form
					registrationId={registrationId}
					registration={registration}
					projects={projects}
					users={users}
					workers={workers}
					projectWorks={projectWorks}
				/>
			{/*// )}*/}
		</SkeletonLoaderWrapper>
	)
};

// export default Create
export default withPermissionHOC(Create, [access_registrations])